__turbopack_context__.v({
  "pill": "pdUcRG_pill",
});
